import { render, staticRenderFns } from "./SmartLinkCard.vue?vue&type=template&id=0939603c&scoped=true&"
import script from "./SmartLinkCard.vue?vue&type=script&lang=js&"
export * from "./SmartLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./SmartLinkCard.vue?vue&type=style&index=0&id=0939603c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0939603c",
  null
  
)

export default component.exports